import { useTranslation } from 'react-i18next';
import { useIsEditMode } from 'pages/documents_v2/hooks/useIsEditMode';
import { NumberParam, useQueryParam } from 'use-query-params';

export function EmptyAreaPlaceholder() {
    const isEditMode = useIsEditMode();
    const { t } = useTranslation('documents');
    const [, setInsertBlockIndex] = useQueryParam('ibi', NumberParam);

    return (
        <div className="py-4 text-secondary justify-content-left" style={{ border: '1px dashed #e5e5e5' }}>
            <div className="ml-4">
                {t('document.navbar.main.editor.left.blocks.noContent')}&nbsp;
                {isEditMode && (
                    <span className="links">
                        <a href="#" onClick={(event) => addNewBlock(event)}>
                            {t('documents:document.navbar.main.editor.left.blocks.addBlock')}
                        </a>
                        .
                    </span>
                )}
            </div>
        </div>
    );

    function addNewBlock(event) {
        event.preventDefault();
        setInsertBlockIndex(0);
    }
}
